import { formatCurrency } from 'helpers/formatData';

export const usersAcquiredRows = (report) => {
  return {
    firstName: report?.legalName ?? 'NA',
    state: report?.state ?? 'NA',
    isKYCVerified: report?.status ?? 'NA',
    isAdminApproved: report?.status ?? 'NA',
    investmentStatus: report?.investmentStatus ?? 'NA',
  };
};

export const usersByStateRows = (report) => {
  return {
    state: report?.state ?? 'NA',
    users: report?.users ?? 0,
    totalInvestments: formatCurrency(report?.totalInvestment ?? 0),
  };
};

export const usersByAgeRows = (report) => {
  return {
    ageGroup: report?.ageGroup ?? 'NA',
    investors: report?.users ?? 0,
    totalInvestment: formatCurrency(report?.totalInvestment ?? 0),
  };
};
